<template>
  <ats
    v-bind="$props"
    service="horizontal"
    :savingConf="savingConf"
    :credential="{
      url: '',
      meta: ''
    }"
    :cached="true"
    @input="onInput">
    <template v-slot:credential="{ credential }">
      <div>
        <label for="url">url</label>
        <input v-model="credential.url" id="url" name="url"/>
        <modified :enable="value.credential.url !== credential.url"/>
      </div>
      <div class="meta">
        <label for="meta">meta</label>
        <textarea v-model="credential.meta" id="meta" name="meta"></textarea>
        <modified :enable="value.credential.meta !== credential.meta"/>
      </div>
    </template>
  </ats>
</template>
<script>
import Ats from './sdk-v3'
import Recruiter from '/user/recruiter/recruiter.entity'
import Search from '/requirement/entity'
import Modified from '/ats/modified'

export default {
  name: 'hippolyte.services.horizontal.config',
  components: { Ats, Modified },
  props: {
    value: Object,
    recruiter: Recruiter,
    search: Search,
    savingConf: Boolean
  },
  methods: {
    onInput (event) {
      this.$emit('input', event)
    }
  }
}
</script>
